import { useTranslation } from '@getpopsure/i18n-react';
import { Table } from '@popsure/dirty-swan';
import Markdown from 'components/markdown';
import { isMobileApp } from 'shared/util/isMobileApp';

import { LegalQuotePlan } from '../models';
import { getTableData } from './tableData/legal';

export const ComparisonTable = ({
  showPrice,
  planMapping,
}: {
  showPrice: boolean;
  planMapping: LegalQuotePlan;
}) => {
  const { t } = useTranslation();
  const tableData = getTableData(t, showPrice, planMapping);

  return (
    <Table
      title="Coverage overview"
      tableData={tableData}
      collapsibleSections
      stickyHeaderTopOffset={isMobileApp ? 88 : 0}
      modalContentRenderer={(markdown) =>
        typeof markdown === 'string' ? (
          <Markdown>{markdown}</Markdown>
        ) : (
          markdown
        )
      }
    />
  );
};
